import {v3} from "oc-threejs/short3.js";
import Restraint from "./Restraint.js";

/**
 * Positioniert das Objekt gar nicht, sondern wird immer aktiv.
 * Kann somit als Sensor verwendet werden, indem man die onXY - Methoden überschreibt.
 */
export default class AnyRestraint extends Restraint {

    constructor(options) {
        super(options);
        this.additively = this.options==null || this.options.additively==null ? true : this.options.additively;
        this.priority = this.options==null || this.options.priority==null ? Number.MAX_SAFE_INTEGER : this.options.priority;
    }

    /**
     * @param {THREE.Raycaster} raycaster
     * @returns {?{distance:number, point:THREE.Vector3, restraint:Restraint}}
     */
    raycastWorld(raycaster) {
        return {
            distance: Number.POSITIVE_INFINITY,
            point: v3(),
            restraint: this,
        };
    }

    /**
     * @param {THREE.Raycaster} raycaster
     * @param {THREE.Vector3} point
     * @param {boolean} dropped
     */
    perform(raycaster, point, dropped) {
    }

}
